// extracted by mini-css-extract-plugin
export default {"container":"receiptLayout_container__O5x+E","content":"receiptLayout_content__KoIwn"};